import { render, staticRenderFns } from "./listMessageTemplate.vue?vue&type=template&id=4e9e6164&scoped=true"
import script from "./listMessageTemplate.vue?vue&type=script&lang=js"
export * from "./listMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./listMessageTemplate.vue?vue&type=style&index=0&id=4e9e6164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e6164",
  null
  
)

export default component.exports